import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import { css } from 'styled-components';
export var COLOR_VARIABLES = {
  NEUTRAL_800: '--neutral-800',
  NEUTRAL_750: '--neutral-750',
  NEUTRAL_700: '--neutral-700',
  NEUTRAL_650: '--neutral-650',
  NEUTRAL_600: '--neutral-600',
  NEUTRAL_550: '--neutral-550',
  NEUTRAL_500: '--neutral-500',
  NEUTRAL_450: '--neutral-450',
  NEUTRAL_400: '--neutral-400',
  NEUTRAL_350: '--neutral-350',
  NEUTRAL_300: '--neutral-300',
  NEUTRAL_250: '--neutral-250',
  NEUTRAL_200: '--neutral-200',
  NEUTRAL_150: '--neutral-150',
  NEUTRAL_100: '--neutral-100',
  NEUTRAL_50: '--neutral-50',
  WHITE: '--white',
  POSITIVE_800: '--positive-800',
  POSITIVE_750: '--positive-750',
  POSITIVE_700: '--positive-700',
  POSITIVE_650: '--positive-650',
  POSITIVE_600: '--positive-600',
  POSITIVE_550: '--positive-550',
  POSITIVE_500: '--positive-500',
  POSITIVE_450: '--positive-450',
  POSITIVE_400: '--positive-400',
  POSITIVE_350: '--positive-350',
  POSITIVE_300: '--positive-300',
  POSITIVE_250: '--positive-250',
  POSITIVE_200: '--positive-200',
  POSITIVE_150: '--positive-150',
  POSITIVE_100: '--positive-100',
  POSITIVE_50: '--positive-50',
  NEGATIVE_800: '--negative-800',
  NEGATIVE_750: '--negative-750',
  NEGATIVE_700: '--negative-700',
  NEGATIVE_650: '--negative-650',
  NEGATIVE_600: '--negative-600',
  NEGATIVE_550: '--negative-550',
  NEGATIVE_500: '--negative-500',
  NEGATIVE_450: '--negative-450',
  NEGATIVE_400: '--negative-400',
  NEGATIVE_350: '--negative-350',
  NEGATIVE_300: '--negative-300',
  NEGATIVE_250: '--negative-250',
  NEGATIVE_200: '--negative-200',
  NEGATIVE_150: '--negative-150',
  NEGATIVE_100: '--negative-100',
  NEGATIVE_50: '--negative-50',
  NOTICE_800: '--notice-800',
  NOTICE_750: '--notice-750',
  NOTICE_700: '--notice-700',
  NOTICE_650: '--notice-650',
  NOTICE_600: '--notice-600',
  NOTICE_550: '--notice-550',
  NOTICE_500: '--notice-500',
  NOTICE_450: '--notice-450',
  NOTICE_400: '--notice-400',
  NOTICE_350: '--notice-350',
  NOTICE_300: '--notice-300',
  NOTICE_250: '--notice-250',
  NOTICE_200: '--notice-200',
  NOTICE_150: '--notice-150',
  NOTICE_100: '--notice-100',
  NOTICE_50: '--notice-50',
  PRIMARY_800: '--primary-800',
  PRIMARY_750: '--primary-750',
  PRIMARY_700: '--primary-700',
  PRIMARY_650: '--primary-650',
  PRIMARY_600: '--primary-600',
  PRIMARY_550: '--primary-550',
  PRIMARY_500: '--primary-500',
  PRIMARY_450: '--primary-450',
  PRIMARY_400: '--primary-400',
  PRIMARY_350: '--primary-350',
  PRIMARY_300: '--primary-300',
  PRIMARY_250: '--primary-250',
  PRIMARY_200: '--primary-200',
  PRIMARY_150: '--primary-150',
  PRIMARY_100: '--primary-100',
  PRIMARY_50: '--primary-50',
  SECONDARY_800: '--secondary-800',
  SECONDARY_750: '--secondary-750',
  SECONDARY_700: '--secondary-700',
  SECONDARY_650: '--secondary-650',
  SECONDARY_600: '--secondary-600',
  SECONDARY_550: '--secondary-550',
  SECONDARY_500: '--secondary-500',
  SECONDARY_450: '--secondary-450',
  SECONDARY_400: '--secondary-400',
  SECONDARY_350: '--secondary-350',
  SECONDARY_300: '--secondary-300',
  SECONDARY_250: '--secondary-250',
  SECONDARY_200: '--secondary-200',
  SECONDARY_150: '--secondary-150',
  SECONDARY_100: '--secondary-100',
  SECONDARY_50: '--secondary-50',
  LIGHT: '--neutral-100',
  LIGHT_GREY: '--neutral-200',
  MID_GREY: '--neutral-300',
  GREY: '--neutral-400',
  DARK_GREY: '--neutral-500',
  BLACK: '--neutral-800',
  DARKEST: '--neutral-700',
  ERROR: '--negative-500',
  WARNING: '--notice-500',
  PURPLE: '--purple',
  ORANGE: '--orange',
  GREEN: '--green',
  TEAL: '--teal',
  PRIMARY_1: '--primary-1',
  PRIMARY_2: '--primary-2',
  PRIMARY_3: '--primary-3',
  PRIMARY_4: '--primary-4',
  PRIMARY_5: '--primary-5',
  SECONDARY_1: '--secondary-1',
  FOCUS: '--focus',
  FOCUS_DARK: '--focus-dark',
  BACKGROUND_1: '--background-1',
  BACKGROUND_2: '--background-2',
  LIGHT_RED: '--light-red'
};
export var baseColors = /*#__PURE__*/css(["", ":#010101;", ":#0F1014;", ":#1A1B22;", ":#262832;", ":#30323F;", ":#3D4151;", ":#4C5165;", ":#555B71;", ":#6A7187;", ":#9196AA;", ":#B0B5CA;", ":#C9CFE3;", ":#D5DCEC;", ":#E9EEF9;", ":#F4F7FF;", ":#F9FCFF;", ":#FFFFFF;", ":#140F01;", ":#3D2E00;", ":#513D00;", ":#654C00;", ":#8E6B00;", ":#A27A00;", ":#B78900;", ":#CB9801;", ":#F4B601;", ":#FEC008;", ":#FFC82A;", ":#FFD55D;", ":#FEE085;", ":#FEF1C2;", ":#FFF4D6;", ":#FFFAEA;", ":#120203;", ":#360709;", ":#5B0A0F;", ":#6D0D12;", ":#7F1115;", ":#A2131B;", ":#B6161E;", ":#C81820;", ":#E01B25;", ":#E63740;", ":#EB5C63;", ":#EE8084;", ":#F29297;", ":#F9C9CB;", ":#FBDBDB;", ":#FDEDEE;", ":#071302;", ":#0F2702;", ":#173A03;", ":#1E4D03;", ":#246005;", ":#2E7308;", ":#338708;", ":#3D9A07;", ":#43AE0A;", ":#53D40D;", ":#5BE70C;", ":#7EF43D;", ":#A5F778;", ":#BEF99F;", ":#D8FCC5;", ":#F1FEEB;", ":#42368E;", ":#F3C13F;", ":#228B22;", ":#03DAD5;", ":#FD5E5E;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;", ":transparent;"], COLOR_VARIABLES.NEUTRAL_800, COLOR_VARIABLES.NEUTRAL_750, COLOR_VARIABLES.NEUTRAL_700, COLOR_VARIABLES.NEUTRAL_650, COLOR_VARIABLES.NEUTRAL_600, COLOR_VARIABLES.NEUTRAL_550, COLOR_VARIABLES.NEUTRAL_500, COLOR_VARIABLES.NEUTRAL_450, COLOR_VARIABLES.NEUTRAL_400, COLOR_VARIABLES.NEUTRAL_350, COLOR_VARIABLES.NEUTRAL_300, COLOR_VARIABLES.NEUTRAL_250, COLOR_VARIABLES.NEUTRAL_200, COLOR_VARIABLES.NEUTRAL_150, COLOR_VARIABLES.NEUTRAL_100, COLOR_VARIABLES.NEUTRAL_50, COLOR_VARIABLES.WHITE, COLOR_VARIABLES.NOTICE_800, COLOR_VARIABLES.NOTICE_750, COLOR_VARIABLES.NOTICE_700, COLOR_VARIABLES.NOTICE_650, COLOR_VARIABLES.NOTICE_600, COLOR_VARIABLES.NOTICE_550, COLOR_VARIABLES.NOTICE_500, COLOR_VARIABLES.NOTICE_450, COLOR_VARIABLES.NOTICE_400, COLOR_VARIABLES.NOTICE_350, COLOR_VARIABLES.NOTICE_300, COLOR_VARIABLES.NOTICE_250, COLOR_VARIABLES.NOTICE_200, COLOR_VARIABLES.NOTICE_150, COLOR_VARIABLES.NOTICE_100, COLOR_VARIABLES.NOTICE_50, COLOR_VARIABLES.NEGATIVE_800, COLOR_VARIABLES.NEGATIVE_750, COLOR_VARIABLES.NEGATIVE_700, COLOR_VARIABLES.NEGATIVE_650, COLOR_VARIABLES.NEGATIVE_600, COLOR_VARIABLES.NEGATIVE_550, COLOR_VARIABLES.NEGATIVE_500, COLOR_VARIABLES.NEGATIVE_450, COLOR_VARIABLES.NEGATIVE_400, COLOR_VARIABLES.NEGATIVE_350, COLOR_VARIABLES.NEGATIVE_300, COLOR_VARIABLES.NEGATIVE_250, COLOR_VARIABLES.NEGATIVE_200, COLOR_VARIABLES.NEGATIVE_150, COLOR_VARIABLES.NEGATIVE_100, COLOR_VARIABLES.NEGATIVE_50, COLOR_VARIABLES.POSITIVE_800, COLOR_VARIABLES.POSITIVE_750, COLOR_VARIABLES.POSITIVE_700, COLOR_VARIABLES.POSITIVE_650, COLOR_VARIABLES.POSITIVE_600, COLOR_VARIABLES.POSITIVE_550, COLOR_VARIABLES.POSITIVE_500, COLOR_VARIABLES.POSITIVE_450, COLOR_VARIABLES.POSITIVE_400, COLOR_VARIABLES.POSITIVE_350, COLOR_VARIABLES.POSITIVE_300, COLOR_VARIABLES.POSITIVE_250, COLOR_VARIABLES.POSITIVE_200, COLOR_VARIABLES.POSITIVE_150, COLOR_VARIABLES.POSITIVE_100, COLOR_VARIABLES.POSITIVE_50, COLOR_VARIABLES.PURPLE, COLOR_VARIABLES.ORANGE, COLOR_VARIABLES.GREEN, COLOR_VARIABLES.TEAL, COLOR_VARIABLES.LIGHT_RED, COLOR_VARIABLES.PRIMARY_800, COLOR_VARIABLES.PRIMARY_750, COLOR_VARIABLES.PRIMARY_700, COLOR_VARIABLES.PRIMARY_650, COLOR_VARIABLES.PRIMARY_600, COLOR_VARIABLES.PRIMARY_550, COLOR_VARIABLES.PRIMARY_500, COLOR_VARIABLES.PRIMARY_450, COLOR_VARIABLES.PRIMARY_400, COLOR_VARIABLES.PRIMARY_350, COLOR_VARIABLES.PRIMARY_300, COLOR_VARIABLES.PRIMARY_250, COLOR_VARIABLES.PRIMARY_200, COLOR_VARIABLES.PRIMARY_150, COLOR_VARIABLES.PRIMARY_100, COLOR_VARIABLES.PRIMARY_50, COLOR_VARIABLES.SECONDARY_800, COLOR_VARIABLES.SECONDARY_750, COLOR_VARIABLES.SECONDARY_700, COLOR_VARIABLES.SECONDARY_650, COLOR_VARIABLES.SECONDARY_600, COLOR_VARIABLES.SECONDARY_550, COLOR_VARIABLES.SECONDARY_500, COLOR_VARIABLES.SECONDARY_450, COLOR_VARIABLES.SECONDARY_400, COLOR_VARIABLES.SECONDARY_350, COLOR_VARIABLES.SECONDARY_300, COLOR_VARIABLES.SECONDARY_250, COLOR_VARIABLES.SECONDARY_200, COLOR_VARIABLES.SECONDARY_150, COLOR_VARIABLES.SECONDARY_100, COLOR_VARIABLES.SECONDARY_50, COLOR_VARIABLES.PRIMARY_1, COLOR_VARIABLES.PRIMARY_2, COLOR_VARIABLES.PRIMARY_3, COLOR_VARIABLES.PRIMARY_4, COLOR_VARIABLES.PRIMARY_5, COLOR_VARIABLES.SECONDARY_1, COLOR_VARIABLES.FOCUS, COLOR_VARIABLES.FOCUS_DARK, COLOR_VARIABLES.BACKGROUND_1, COLOR_VARIABLES.BACKGROUND_2);
export var COLORS = Object.keys(COLOR_VARIABLES).reduce(function (acc, key) {
  return _extends({}, acc, _defineProperty({}, key, "var(".concat(COLOR_VARIABLES[key], ")")));
}, {});